// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { number, string } from 'prop-types'
import { UNCAUGHT_ERROR } from 'errors'
import { fetchSegmentEndACM } from 'helpers/api'
import LoadingIcon from 'components/LoadingIcon'
import ModulationRow from './ModulationRow'

class ACMTooltip extends React.Component {
  static propTypes = {
    idRoot: string.isRequired,
    tooltipData: number.isRequired,
  }

  state = {
    error: '',
    loading: true,
    modulations: [],
  }

  componentWillMount () {
    return this.assignACMtoState()
  }

  componentWillReceiveProps (np, ns) {
    if (np.tooltipData !== this.props.tooltipData) {
      this.clearACMFromState()
      return this.assignACMtoState()
    }
  }

  // fetches and assigns ACM data to the component state.
  assignACMtoState = async () => {
    // this will be the segment end id which has the radio we're interested in.
    const { tooltipData } = this.props

    let error = ''
    const loading = false
    const modulations = []

    try {
      const { entities } = await fetchSegmentEndACM(tooltipData)

      if (!entities.length) {
        throw new Error('No modulations were found.')
      }

      modulations.push(...entities)
    } catch (err) {
      console.warn(err)
      error = err.message || UNCAUGHT_ERROR
    }

    this.setState(() => ({
      error,
      loading,
      modulations,
      tooltipData,
    }))
  }

  // clears the component state, so we can start anew
  clearACMFromState = () => {
    this.setState(() => ({
      error: '',
      loading: true,
      modulations: [],
    }))
  }

  render () {
    const { idRoot } = this.props

    const {
      error,
      loading,
      modulations,
    } = this.state

    return (
      <dl className={'modulations-tooltip scoot-left position-relative'}>
        <dt className={'flex-wrap-wrap'}>
          <p className={'tooltip-trigger-decoration show-decoration acm-tooltip-decoration'}>
            {'ACM'}
          </p>
          <p>{'Adaptive Modulation'}</p>
          {!!error.length && <div className={'error-message width-100'}>{error}</div>}
          {loading && <LoadingIcon loading={loading} />}
        </dt>
        <dd>
          <table>
            <thead>
              <tr>
                <th>
                  {'Modulation /'}
                  <br/>
                  {'Throughput (Mbps)'}
                </th>
                <th>
                  {'Power'}
                  <br />
                  {'(dBm)'}
                </th>
              </tr>
            </thead>
            <tbody>
              {modulations.map((d, i) => (
                <ModulationRow
                  key={i}
                  {...d}
                  idRoot={`${idRoot}${i}-`} />
              ))}
            </tbody>
          </table>
        </dd>
      </dl>
    )
  }
}

export default ACMTooltip
